import { faCirclePlay, faTrashXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAlertService from "@mirage/hooks/useAlertService";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import ApplicationStatusCell from "@publicPortal/components/applicationStatusCell/ApplicationStatusCell";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { TrackedApplicationService } from "@publicPortal/services/TrackedApplicationService";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import { useNavigate } from "react-router-dom";

const TrackedAppTableColumns = (recordDeleted: React.Dispatch<React.SetStateAction<boolean>>): GridColDef[] => {
    const trackedApplicationService = new TrackedApplicationService();
    const navigate = useNavigate();
    const pp = new PublicPortalRoutingService();
    const showAlert = useAlertService();

    return [
        {
            field: "actions",
            headerName: "Actions",
            renderCell: (params: GridRenderCellParams) => getActions(params.row.id, params.row.paId),
            maxWidth: 120,
            sortable: false,
            resizable: false,
            groupable: false,
        },
        { field: "name", headerName: "Application Reference", flex: 0.25 },
        { field: "address", headerName: "Address", flex: 1 },
        { field: "appTypeName", headerName: "Type", flex: 0.5 },
        { field: "applicationStatus", headerName: "Status", flex: 0.25, renderCell: (params) => <ApplicationStatusCell applicationStatus={params.value} /> },
    ] as GridColDef[];

    function getActions(trackedId: number, paId: number) {
        return (
            <>
                <Tooltip title="Go to record" placement="top">
                    <IconButton onClick={() => navigate(pp.PlanningApplicationRecordRoute(paId))}>
                        <FontAwesomeIcon icon={faCirclePlay} color={PublicPortalTheme.palette.success.main} style={PublicPortalTheme.icons.sizeM} />
                    </IconButton>
                </Tooltip>
                <Tooltip title="Delete Track" placement="top">
                    <IconButton onClick={async () => await handleDeleteRecord(trackedId)}>
                        <FontAwesomeIcon icon={faTrashXmark} color={PublicPortalTheme.palette.error.main} style={PublicPortalTheme.icons.sizeM} />
                    </IconButton>
                </Tooltip>
            </>
        );
    }

    async function handleDeleteRecord(trackedId: number) {
        const result = await trackedApplicationService.deleteTrackedApplication(trackedId);
        if (result.errorMsg) {
            showAlert(result.errorMsg, "error");
        } else {
            showAlert("You successfully untracked application", "success");
        }
        recordDeleted((prev) => !prev);
    }
};

export default TrackedAppTableColumns;
